<template>
    <div class="secondary-menu moderation_photo">
        <div class="secondary-menu-header">
          <i class="back" @click="goBack"></i>
          <div class="title">{{ trans('moderation') }}</div>
        </div>

        <div class="secondary-menu-body">
          <div class="moderation">
            <div v-if="!loaded && !photos.length" class="spinner-container">
              <img class="preloader"
                   src="/assets/img/preloader.svg"
                   alt="">
            </div>
            <div v-else-if="photos.length">
              <div v-if="photos.length" class="photo-preview" :style="{'background': `url(${photos[0].url}) no-repeat center / cover`}">
              </div>
              <div class="buttons">
                <div class="rounded">
                  <button @click="ratePhoto(photos[0].id, 'safe')" class="green">safe</button>
                  <button @click="ratePhoto(photos[0].id, 'soft')" class="yellow">soft</button>
                  <button @click="ratePhoto(photos[0].id, 'hard')" class="purple">hard</button>
                </div>
                <div class="bottom-buttons">
                  <button @click="ratePhoto(photos[0].id, 'prohibited')" class="report">!</button>
                  <button @click="sendRequest" class="skip" :class="rateClass">{{skipText}}</button>
                </div>
              </div>
            </div>
            <div class="not_exists" v-else>
              Images for moderation not exists, try again later
            </div>
          </div>
        </div>
      </div>
</template>

<script>

    import {mapActions} from "vuex";

    export default {
        mixins: [require('@general/lib/mixin').default],
        data() {
            return {
              photos: [],
              current_rate:null,
              skipped_photos: 0,
              loaded: false
            }
        },
        components: {
        },
        computed:{
          skipText(){
            if(this.current_rate){
              if(this.current_rate === 'prohibited'){
                return 'report';
              }else{
                return 'send';
              }
            }else{
              return 'skip';
            }
          },
          rateClass(){
            let classes = {
              'safe' : 'green',
              'soft' : 'yellow',
              'hard' : 'purple',
              'prohibited' : 'red'
            };
            if(this.current_rate){
              return classes[this.current_rate];
            }else{
              return '';
            }
          }
        },
        mounted() {
          this.getPhotosForModeration();
        },
        beforeDestroy() {
        },
        methods: {
          ...mapActions([
            'closeProfileModerations',
            'openProfileHelp'
          ]),
          goBack(){
            if(this.isDesktop){
              this.closeProfileModerations();
              this.openProfileHelp();
            }else{
              this.goTo('/profile/help')
            }
          },
          sendRequest(){
            let rate = this.current_rate ? this.current_rate : 'skip';
            let rates = {
              'safe' : 'clear',
              'soft' : 'soft',
              'hard' : 'adult',
              'prohibited' : 'prohibited',
              'skip' : 'skip'
            };
            let photo_id = this.photos[0].id;
            axios.post(`/api/photos/ratePhoto`, {photo_id: photo_id,rate:rates[rate]})
                .then((data) => {
                  if(data.data.success){

                  }
                })
            if(this.photos.length - 1 <= 2 && this.loaded){
              this.getPhotosForModeration();
            }
            this.photos.splice(0, 1)
            if(rate === 'skip'){
              this.skipped_photos += 1;
            }
            if(this.skipped_photos > 4){
              this.photos = [];
              this.current_rate = null;
            }else{
              this.current_rate = null;
            }

          },
          ratePhoto(id, rate){
            if(this.current_rate && this.current_rate === rate){
              this.current_rate = null;
            }else{
              this.current_rate = rate;
            }
          },
          getPhotosForModeration(){
            let self = this;
            self.loaded = false;
            axios.get(`/api/photos/getModerationPhotos?except=` + this.photos.map(({id}) => ( id )).join(','))
                .then((photos) => {
                  self.loaded = true;
                  self.photos = self.photos.concat(photos.data);
                })

          },
        }
    }
</script>